.modal90w {
  max-width: none !important;
  width: 90%;
}

.modal75w {
  max-width: none !important;
  width: 75%;
}

.modal50w {
  max-width: none !important;
  width: 60%;
}

// Native CSS resize handle on the modal dialog. Triggered by `resizable={true}` on
// `<Modal>`. The browser renders a small grip glyph in the bottom-right of the visible white
// box; dragging it sets inline width/height that override any width/height set by .modal90w
// / dialogClassName rules.
//
// `resize: both` is applied to `.modal-content` rather than `.modal-dialog` because
// `.modal-content` is what the user actually sees (the white rounded box). `.modal-dialog`
// is the outer wrapper, and its bottom-right grip would be obscured behind `.modal-content`
// which covers the same bounding rect with `pointer-events: auto`. Putting the resize on
// `.modal-content` puts the grip on top, where it can receive clicks.
//
// `overflow: hidden` is required for the resize handle to render — without it, the
// user-agent's grip glyph is suppressed. Body scroll still works because the modal body
// has its own `overflow-y: auto` inside `.modal-content`, from Bootstrap's `.modal-dialog-scrollable`
// that `<Modal resizable>` turns on (node_modules/bootstrap5/scss/_modal.scss:75-86). That class also caps
// `.modal-content` at the dialog's height, the viewport minus the dialog's own margin.
.resizable :global(.modal-content) {
  resize: both;
  overflow: hidden;
  min-width: 20rem;
  min-height: 12rem;
  max-width: 100vw;
}

// `FormModal` wraps its body and footer in a `<form>`, which sits between `.modal-content` and
// them. Make it a shrinking flex column so the body's scroll reaches the footer there too.
.resizable :global(.modal-content) > form {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}
